import React from 'react'

const SvgIconBookOpen = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 3a1 1 0 0 1 1-1h6a5 5 0 0 1 5 5v14a1 1 0 1 1-2 0 2 2 0 0 0-2-2H2a1 1 0 0 1-1-1V3zm10 14.536V7a3 3 0 0 0-3-3H3v13h6a4 4 0 0 1 2 .536z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.464 3.464A5 5 0 0 1 16 2h6a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-7a2 2 0 0 0-2 2 1 1 0 1 1-2 0V7a5 5 0 0 1 1.464-3.536zM13 17.536A4 4 0 0 1 15 17h6V4h-5a3 3 0 0 0-3 3v10.536z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconBookOpen
